var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ma-5"},[_c('titleAgency'),_c('filterAgency'),_c('tableAgency')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }